import { Component } from '@angular/core';
import { HeaderComponent } from '../shared/header/header.component';
import { FooterComponent } from '../shared/footer/footer.component';
import { RouterLink, RouterOutlet } from '@angular/router';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-user',
  imports: [HeaderComponent,FooterComponent,RouterOutlet,CommonModule,RouterLink],
  templateUrl: './user.component.html',
  styleUrl: './user.component.css'
})
export class UserComponent {
showPopup = false;

  ngOnInit(): void {
    const decision = localStorage.getItem('cookieDecision');
    if (!decision) {
      this.showPopup = true;
    }
  }

  accept(): void {
    localStorage.setItem('cookieDecision', 'accepted');
    this.showPopup = false;
  }

  decline(): void {
    localStorage.setItem('cookieDecision', 'declined');
    this.showPopup = false;
  }
  close(){
    this.showPopup = false;
  }
}
